var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{staticStyle:{"margin-bottom":"20px"},attrs:{"type":"primary","icon":"el-icon-back","plain":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(_vm._s(_vm.$t('back')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }